// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8096 ? "vendors" : chunkId) + "." + {"527":"0d6697abbcf4a1e5ee88","8096":"1d3da6a4127c0d070c7b","8135":"a9e2e4fc5bf405a1be08","8579":"48ce854ff60318f5d697","9545":"306430f2ff11f82c8b6d"}[chunkId] + ".js";
};